import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from './../../../../../../shared/util/util';
import TripServices from '../../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service'
import Loader from '../../../../../../shared/components/loader';

export default {
  name: 'firstmilemgmt',
  props:['parentOBJ'],
  components: {
    Loader,
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading
  },
  data() {
    return {
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Delivery ID', 'Client Name','Delivery Address','AWB','Number of MPS','Total Physical Weight (kg)'],
      innerTableColumn: ['Assigned'],
      tableItems: [],
      offset: 0,
      LMcount:'',
      isLoading:false,
      drsid:''
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getTripData();
  },
  methods: {
    async getTripData() {
      try {
        this.isLoading=true;
        let payload = {
          offset: 0,
          limit: 100,
          TripId: this.parentOBJ.tripID,
          type: "LastMile"
        }
        let result=await TripServices.GetSelectedAWB(payload)
        if(result.data.data.count>0){
        this.LMcount=result.data.data.count
        this.drsid=result.data.data.drsid
          this.tableItems=result.data.data.sheetData.map(item=>{
            return{
              'id': item.id,
              'Delivery ID':"D-"+this.parentOBJ.tmstripid,
              'Client Name':item.clientname,
              'Delivery Address':item.address,
              'AWB':item.awb,
              'Number of MPS':item.numberofmps,
              'Total Physical Weight (kg)':item.bookingphysicalwt,
            }
          })
        this.$emit('getLMcount',this.LMcount)
        }
        else{
        this.LMcount=0
        }
        this.isLoading=false;
      } catch (error) {
        console.log(error.message);
        this.isLoading=false;
      }
    },
    getCustomTableEvent(){}
    },
  }



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/TripShipment/lastmileShipment/lastmileShipment.component.js